module.exports = __webpack_public_path__ + "img/art-time-icon2.499fa127.png";